export default class CrmFormEmbed {
    static init() {
        document.querySelectorAll('iframe[data-crm-embed]').forEach(element => {
            if (element.dataset.crmInitialized) return;
            element.dataset.crmInitialized = 'true';
            new CrmFormEmbed(element);
        });
    }

    constructor(iframe) {
        let url;
        try { url = new URL(iframe.src); } catch { return; }
        if (url.protocol !== 'https:') return;
        window.addEventListener('message', event => {
            if (event.source !== iframe.contentWindow || event.origin !== url.origin || typeof event.data !== 'string') return;
            const match = /^resize::(\d{1,5})$/.exec(event.data);
            if (match) iframe.height = String(Math.min(5000, Math.max(200, Number(match[1]))));
        });
    }
}
